import React from 'react';

import { useAlloyFeatureFlag } from '@adsk/alloy-provider';
import { MagnifyingGlassIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import TextInput from '@adsk/alloy-react-text-input';
import theme from '@adsk/alloy-react-theme';

import ReferencePickerPlugin from '../../../types/ReferencePickerPlugin';
import { SubmittalsItem } from '../types';

const SearchBox: ReferencePickerPlugin<SubmittalsItem>['CustomPickerSearchBox'] =
  ({ searchExpression, onSearchChange, disabled }) => {
    const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
    const { value: customNumberingFF } = useAlloyFeatureFlag(
      'submittals-custom-numbering-fe',
    );

    return (
      <TextInput
        style={{
          width: 300,
          'input:disabled': {
            background: theme.colors.white,
          },
        }}
        renderRightElement={(p) => <MagnifyingGlassIcon {...p} />}
        placeholder={T.translate(
          customNumberingFF
            ? 'SEARCH_BOX_PLACEHOLDER_WITH_CUSTOM_NUMBER'
            : 'SEARCH_BOX_PLACEHOLDER',
        )?.toString()}
        value={searchExpression || ''}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onSearchChange(e.target.value)
        }
        disabled={disabled}
      />
    );
  };

SearchBox.displayName = 'SubmittalsSearchBox';

export default SearchBox;
